function getoverlay() {
    return document.querySelector('.js_promises__tooltipOverlay');
}

function openTooltip(openButton) {
    const tooltipId = openButton.getAttribute('data-for-tooltip'),
        overlay = getoverlay();

    let tooltip;

    if (tooltipId) {
        tooltip = document.querySelector(`[data-tooltip=${tooltipId}]`);
    }

    if (tooltip) {
        tooltip.classList.add('promises__tooltip--visible');
    }

    if (tooltip && overlay) {
        overlay.classList.add('promises__tooltipOverlay--visible');
    }
}

function closeTooltip(closeButton) {
    const tooltip = closeButton.closest('.js_promises__tooltip'),
        overlay = getoverlay();

    if (tooltip) {
        tooltip.classList.remove('promises__tooltip--visible');
    }

    if (tooltip && overlay) {
        overlay.classList.remove('promises__tooltipOverlay--visible');
    }
}

function init() {
    const openButtons = [...document.querySelectorAll('.js_promises__tooltipOpenButton')],
        closeButtons = [...document.querySelectorAll('.js_promises__tooltipCloseButton')];
    
    openButtons.forEach(openButton => openButton.addEventListener('click', e => openTooltip(openButton)));

    closeButtons.forEach(closeButton => closeButton.addEventListener('click', e => closeTooltip(closeButton)));
}

$(document).ready(init);
